import { FunctionComponent, useState } from 'react'
import WorkroomsListing from './WorkroomsListing'
import { useTranslation } from 'react-i18next'
import { Tab, Tabs } from 'react-bootstrap'
import useQueryParams from 'Frontend/hooks/useQueryParams'

interface WorkroomsListOverviewProps {
  createUrl: string | null
  pageName: string | null
}

const WorkroomsListOverview: FunctionComponent<WorkroomsListOverviewProps> = ({ createUrl, pageName }) => {
  const { setQueryParam, getQueryParam } = useQueryParams()

  const [activeType, setActiveType] = useState<string>(getQueryParam('type') || 'Mina arbetsrum')
  const { t } = useTranslation()
  const workroomTypes = [
    { id: 2, name: 'Mina arbetsrum' },
    { id: 3, name: 'Alla arbetsrum' },
    { id: 0, name: 'Nationella' },
    { id: 1, name: 'Regionala' },
  ]

  const onTabChanged = (type: string | null) => {
    if (!type) return

    setActiveType(type)
    setQueryParam('type', type.toString())
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        {pageName && <h2>{pageName}</h2>}
        {createUrl && (
          <a href={createUrl} className="btn btn-secondary">
            {t('create-new-workroom')}
          </a>
        )}
      </div>
      <Tabs defaultActiveKey={activeType} transition={false} className="mt-5 mb-3" fill onSelect={onTabChanged}>
        {workroomTypes.map((type) => (
          <Tab eventKey={type.name} title={type.name} key={type.id}>
            <WorkroomsListing activeType={type.id} />
          </Tab>
        ))}
      </Tabs>
    </>
  )
}
export default WorkroomsListOverview
